"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc");

var _constants = require("./constants"); // @ts-ignore no module typings


var schema = (0, _reactDesc.describe)({
  displayName: 'Avatar'
});
schema.propTypes = {
  email: _reactDesc.PropTypes.string.description("The entity's email address. Used in Gravatar image lookup."),
  color: _reactDesc.PropTypes.string.description('(See note) Sets the color for the background and the icon').defaultValue('information'),
  entityType: _reactDesc.PropTypes.oneOf(Object.values(_constants.entityTypes)).description('Selects the entity type represented.').defaultValue('person'),
  palette: _reactDesc.PropTypes.oneOf(['bright', 'pastel', 'dark']).description('What color variant to render').defaultValue('bright'),
  kind: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.oneOf(Object.values(_constants.kinds))]).description('***DEPRECATED*** Use color + palette instead. Selects the kind of Avatar.').defaultValue('primary').format('***DEPRECATED*** string').deprecated('Use color + palette instead'),
  name: _reactDesc.PropTypes.string.description("The entity's name. First letter of first and last words used to generate initials."),
  size: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.oneOf(Object.values(_constants.sizes))]).description('Selects the size desired.'),
  indicatorColor: _reactDesc.PropTypes.string.description('(See note) Sets the indicator color')
};
var _default = schema;
exports.default = _default;